// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li, #secondary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		$(".faq-filter li").click(function() {
			if($(this).hasClass('active')) {
			} else {
				var target = $(this).attr('data-target');
			    $(".faq-filter li").removeClass('active');
			    $(this).addClass('active');
				$('.faq.container').fadeOut();
				$('#'+target).fadeIn();
			}
		    return false;
		});
		$(".faq__question").click(function() {
			if($(this).parent().hasClass('active')) {
			    $(this).siblings('.faq__answer').slideUp();
			    $(this).removeClass('active');
			} else {
			    $(this).siblings('.faq__answer').slideDown();
			    $(this).parent().addClass('active');
			}
		    return false;
		});
		$(".intro-read-more").click(function() {
			if($(this).hasClass('active')) {
			    $('.intro-expand').slideUp();
			    $(this).removeClass('active');
			    $(this).html('Read More');
			} else {
			    $('.intro-expand').slideDown();
			    $(this).addClass('active');
			    $(this).html('Read Less');
			}
		    return false;
		});
		if($('.tabs__expand').length > 0) {
			$('.tabs__expand').html($(".tabs__links li a.active").html());
			$(".tabs__expand").click(function() {
				$(".tabs__links").slideToggle(); 
				return false;
			});
		}
		$(".tabs__links li a").click(function() {
			if(!$(this).hasClass('active')) {
				var target = $(this).attr('data-id');
			    $(".tabs__links li a").removeClass('active'); 
			    $(".tabs__content").hide();
			    $(this).addClass('active');
			    $("#"+target).show(); 
				if($('.tabs__expand').length > 0 && $(window).width() < 768) {
					$(".tabs__links").slideUp(); 
					$('.tabs__expand').html($(this).html());
				}
			}
		    return false;
		});
		$(".accordion__unit-action").click(function() {
			if(!$(this).hasClass('active')) {
				$(".accordion__unit-action").removeClass('active'); 
				$(".accordion__unit-content").slideUp();
				var target = $(this).attr('data-id');
			    $(this).addClass('active');
			    $("#"+target).slideDown();
			} else {
				$(".accordion__unit-action").removeClass('active'); 
				$(".accordion__unit-content").slideUp();

			}
		    return false;
		});
		$(".toggleMenu").click(function() {
			$(this).toggleClass('active-menu');
			$('body').toggleClass('active-menu'); 
		    return false;
		});
		$(".covid-19-advisory-close").click(function() {
			$('.covid-19-advisory-main').fadeOut();
		    return false;
		});
		$('.livechat').click(function(event) {
			event.preventDefault();
			window.open($(this).attr("href"), "popupWindow", "width=650,height=600,scrollbars=yes");
		});

		$( "#checkindate" ).datepicker({
			changeMonth: true,
			dateFormat: 'yy-mm-dd',
			numberOfMonths: 1,
			minDate: 0, 
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 1);
				$( "#checkoutdate" ).datepicker( "setDate", newDate );
				$( "#checkoutdate" ).datepicker( "option", "minDate", selectedDate );
				// let auxArrDate = selectedDate.split( "/" );
				// $( "#checkindate" ).attr('value', `${auxArrDate[2]}-${auxArrDate[0]}-${auxArrDate[1]}`)
				$( "#checkindate" ).attr('value', newDate)
			}
		});

		$( "#checkoutdate" ).datepicker({
			dateFormat: 'yy-mm-dd',
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				// let auxArrDate = selectedDate.split( "/" );
				// $( "#checkoutdate" ).attr('value', `${auxArrDate/[2]}-${auxArrDate[0]}-${auxArrDate[1]}`)
				$( "#checkoutdate" ).attr('value', newDate)
			}
		});

	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	if(!$('.sidebar').hasClass('no-scroll') && $('.sub-menu').length > 0 && $(window).width() > 767) {
		let submenuPos = $('.sub-menu').offset().top;
		let breakpoint = $('.footer').offset().top-$('.sub-menu').outerHeight()-370;
		$(window).scroll(function() {    
			var scroll = $(window).scrollTop();
			if(scroll >= breakpoint) {
				$('.sub-menu').css('margin-top',(breakpoint-scroll));
			} else {
				$('.sub-menu').css('margin-top',0);
			}
			if (scroll >= submenuPos) {
				$('.sub-menu').addClass('fixx');
			} else {
				$('.sub-menu').removeClass('fixx');
			}
		}); 
	}

}());
function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 10){
		if(!document.getElementById('main').classList.contains('nav-scroll')){
			document.getElementById('main').classList.add('nav-scroll');
		}
	} else {
		if(document.getElementById('main').classList.contains('nav-scroll')){
			document.getElementById('main').classList.remove('nav-scroll');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}